export const EN_MESSAGES = {
  nav: {
    dashboard: 'Dashboard',
    subscriptionPlan: 'Suscripción & plan',
    templates: 'Templates',
    assets: 'Assets',
    scripts: 'Scripts',
    jobs: 'Jobs',
    reports: 'Reports',
    users: 'Users',
    adminSettings: 'Admin Settings',
    plans: 'Plans',
    billingSettings: 'Billing',
    settings: 'Settings',
    logout: 'Logout',
  },
  auth: {
    email: 'Email',
    password: 'Password',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    noAccount: "Don't have an account?",
    register: 'Register',
    createAccount: 'Create account',
    creating: 'Creating...',
    alreadyHaveAccount: 'Already have an account?',
    login: 'Login',
  },
  admin: {
    title: 'Admin Settings',
    loading: 'Loading...',
    retry: 'Retry',
    brandingTitle: 'Branding',
    brandingSubtitle: 'Customize app name, icons and visual identity.',
    appName: 'App name',
    logoText: 'Logo text',
    logoIconUrl: 'Logo icon URL',
    faviconUrl: 'Favicon URL',
    uploadLogo: 'Upload logo',
    uploadFavicon: 'Upload favicon',
    clear: 'Clear',
    paletteTitle: 'Current palette',
    previewTitle: 'Preview',
    localMode: 'Local mode active.',
    save: 'Save changes',
    saving: 'Saving...',
    applyPreview: 'Apply preview',
    resetPreview: 'Reset local preview',
    languageTitle: 'Language Editor',
    languageSubtitle: 'Create, clone from English and edit all fixed texts.',
    languageList: 'Languages',
    languageCode: 'Code',
    languageName: 'Name',
    languageCreate: 'Create language',
    languageCloneFrom: 'Clone from',
    languageEditor: 'Messages JSON',
    languageSave: 'Save language',
    languageSetDefault: 'Set as default',
    languageDelete: 'Delete language',
    languageNew: 'New language',
    onlyImages: 'Only image files are allowed (including SVG).',
    fileTooLarge: 'Image must be 2MB or smaller.',
    fileReadError: 'Could not read the selected file.',
    saved: 'Admin settings saved.',
    loadFailed: 'Could not load Admin Settings.',
    saveFailedLocal: 'Could not save to server. Applied in local mode.',
    localModeFallback: 'API is not reachable right now.',
    colors: {
      accent: 'Accent',
      bgPrimary: 'Background Primary',
      bgSecondary: 'Background Secondary',
      bgSurface: 'Background Surface',
      textPrimary: 'Text Primary',
      textSecondary: 'Text Secondary',
      border: 'Border',
    },
    appliesTenant: 'After saving, changes apply for all users in this tenant.',
    legalContentTitle: 'Legal content',
    legalContentSubtitle: 'Edit the public legal pages shown in the landing footer.',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    legalNotice: 'Legal Notice',
    brandingPreviewDescription: 'Brand and color preview',
    primaryButton: 'Primary Button',
    requiredCodeName: 'Code and Name are required.',
    invalidLanguageJson: 'Language JSON must be valid.',
    createLanguageFailed: 'Could not create language.',
    languageSaved: 'Language saved.',
    languageSaveFailed: 'Could not save language.',
    defaultUpdated: 'Default language updated.',
    defaultUpdateFailed: 'Could not update default language.',
    cannotDeleteEn: 'Cannot delete base language en.',
    deleteLanguageConfirm: 'Delete language {{code}}?',
    deleteLanguageFailed: 'Could not delete language.',
    defaultBadge: 'default',
    // AI Settings
    aiTitle: 'AI Configuration',
    aiSubtitle: 'Configure the AI provider for template and script generation.',
    aiProvider: 'Provider',
    aiApiKey: 'API Key',
    aiApiKeyPlaceholder: 'sk-...',
    aiApiKeySet: 'Key is set',
    aiApiKeyNotSet: 'No key configured',
    aiModel: 'Model',
    aiModelPlaceholder: 'e.g. gpt-4o',
    aiBaseUrl: 'Custom Base URL',
    aiBaseUrlPlaceholder: 'Leave empty for default',
    aiMaxTokens: 'Max Tokens',
    aiTemperature: 'Temperature',
    aiSaveSettings: 'Save AI Settings',
    aiSaved: 'AI settings saved.',
    aiSaveFailed: 'Could not save AI settings.',
    aiClearKey: 'Clear key',
    aiTabTitle: 'AI Config',
    breadcrumbAdmin: 'Admin',
    breadcrumbSettings: 'Settings',
    offlineModeLabel: 'Offline mode',
    identityTitle: 'Identity',
    identitySubtitle: 'App name and logo configuration',
    logoAlt: 'logo',
    faviconAlt: 'favicon',
    upload: 'Upload',
    logoUrlPlaceholder: 'https://.../logo.png',
    faviconUrlPlaceholder: 'https://.../favicon.ico',
    colorPaletteTitle: 'Color Palette',
    colorPaletteSubtitle: 'Customize the visual identity of your application',
    resetPreview: 'Reset preview',
    selectLanguageTitle: 'Select Language',
    selectLanguageSubtitle: 'Choose a language to edit translations',
    createLanguageTitle: 'Create New Language',
    aiProviderModelTitle: 'Provider & Model',
    aiNoneOption: '— None —',
    aiDefaultModelFor: 'Default model for {{provider}}: {{model}}',
    aiCustomModel: 'custom',
    aiAuthTitle: 'Authentication',
    aiNewKeyEntered: 'New key entered — save to apply',
    aiAdvancedTitle: 'Advanced Configuration',
    outlineButton: 'Outline',
    paletteBg: 'BG',
    paletteSurface: 'Surface',
    paletteText: 'Text',
  },
  billing: {
    // Navigation
    navPlans: 'Plans',
    navBillingSettings: 'Billing Settings',
    // Plans page
    plansTitle: 'Billing Plans',
    plansSubtitle: 'Manage plan definitions, limits, and features.',
    createPlan: 'Create Plan',
    editPlan: 'Edit Plan',
    deletePlan: 'Delete Plan',
    planCode: 'Code',
    planName: 'Name',
    planDescription: 'Description',
    planPrice: 'Monthly Price',
    planCurrency: 'Currency',
    planModel: 'Billing Model',
    planModelManual: 'Manual',
    planModelTiered: 'Tiered',
    planModelEnterprise: 'Enterprise',
    planActive: 'Active',
    planInactive: 'Inactive',
    planLimits: 'Limits',
    planFeatures: 'Features',
    plansStatTotal: 'Total plans',
    plansStatActive: 'Active plans',
    plansStatStartingAt: 'Starting at',
    priceAmount: '{{currency}} {{amount}}',
    featuresEnabled: '{{count}} enabled',
    planCodePlaceholder: 'e.g. pro',
    unlimitedHint: 'Use -1 for unlimited',
    planDescriptionEmpty: 'No description',
    confirmDeletePlan: 'Delete plan "{{name}}"?',
    cannotDeleteInUse: 'Cannot delete a plan with active subscriptions.',
    planSaved: 'Plan saved.',
    planCreated: 'Plan created.',
    planDeleted: 'Plan deleted.',
    planSaveFailed: 'Could not save plan.',
    planDeleteFailed: 'Could not delete plan.',
    // Limits labels
    rendersMonth: 'Renders / month',
    concurrentRenders: 'Concurrent renders',
    storageGB: 'Storage (GB)',
    apiCallsPerMinute: 'API calls / min',
    templatesActive: 'Active templates',
    templateVersionsHistory: 'Template versions stored',
    aiGenerationsMonth: 'AI generations / month',
    unlimited: 'Unlimited',
    // Features labels
    studio: 'Studio access',
    apiAccess: 'API access',
    priorityQueue: 'Priority queue',
    customBranding: 'Custom branding',
    aiGeneration: 'AI Generation',
    // Subscriptions
    subscriptions: 'Subscriptions',
    assignPlan: 'Assign Plan',
    tenant: 'Tenant',
    plan: 'Plan',
    status: 'Status',
    period: 'Period',
    confirmPayment: 'Confirm Payment',
    cancelSubscription: 'Cancel',
    noSubscriptions: 'No subscriptions yet.',
    confirmCancelSubscription: 'Cancel this subscription?',
    reactivate: 'Reactivate',
    tenantIdPlaceholder: 'tenant ID',
    statSubscriptions: 'Subscriptions',
    statActive: 'Active',
    statPending: 'Pending',
    subscriptionUpdated: 'Subscription updated.',
    subscriptionCreated: 'Subscription created.',
    paymentConfirmed: 'Payment confirmed. Subscription activated.',
    subscriptionCanceled: 'Subscription canceled.',
    // Billing Settings
    settingsTitle: 'Billing Settings',
    settingsSubtitle: 'Configure billing behavior, trials, and enforcement.',
    refresh: 'Refresh',
    configurationTitle: 'Configuration',
    configurationSubtitle: 'Control how billing works for new and existing users.',
    trialDaysHint: 'Number of free trial days for new users.',
    defaultPlanHint: 'Plan auto-assigned to new editor users.',
    manualPaymentHint: 'Shown to users who need to pay manually.',
    saveSettings: 'Save settings',
    assignPlanTitle: 'Assign Plan',
    assignPlanSubtitle: 'Manually assign a billing plan to a specific user.',
    user: 'User',
    userSearchPlaceholder: 'Search user by email...',
    noUsersFound: 'No users found.',
    tenantId: 'User ID',
    subscriptionsTotal: '{{count}} subscriptions total.',
    processing: 'Processing...',
    loadFailed: 'Failed to load billing data.',
    assignSuccess: 'Plan assigned successfully.',
    assignFailed: 'Failed to assign plan.',
    confirmPaymentSuccess: 'Payment confirmed.',
    confirmPaymentFailed: 'Failed to confirm payment.',
    cancelSubscriptionSuccess: 'Subscription canceled.',
    cancelSubscriptionFailed: 'Failed to cancel subscription.',
    reactivateSuccess: 'Subscription reactivated.',
    reactivateFailed: 'Failed to reactivate subscription.',
    confirmCancelSubscriptionHard: 'Cancel this subscription? This action cannot be undone.',
    manualBilling: 'Manual billing',
    manualBillingDesc: 'When enabled, new users require manual payment confirmation.',
    paymentInstructions: 'Payment instructions',
    paymentInstructionsPlaceholder: 'Wire transfer to account...',
    trialDays: 'Trial days',
    defaultPlan: 'Default plan',
    selectPlan: 'Select a plan...',
    enforceHardLimits: 'Enforce hard limits',
    enforceHardLimitsDesc: 'Block requests that exceed plan limits (vs. soft warning).',
    settingsSaved: 'Billing settings saved.',
    settingsSaveFailed: 'Could not save billing settings.',
    // Statuses
    statusActive: 'Active',
    statusPastDue: 'Past Due',
    statusSuspended: 'Suspended',
    statusCanceled: 'Canceled',
    statusTrialing: 'Trialing',
    statusPendingPayment: 'Pending Payment',
    statusNone: 'No Plan',
    // My billing
    myBilling: 'My Billing',
    currentPlan: 'Current Plan',
    usage: 'Usage This Month',
    of: 'of',
    noPlan: 'No plan assigned.',
    loading: 'Loading...',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
    enabled: 'Enabled',
    disabled: 'Disabled',
    actions: 'Actions',
    back: 'Back',
  },
  templates: {
    title: 'Templates',
    newFolder: 'New Folder',
    newTemplate: 'New Template',
    folders: 'Folders',
    allTemplates: 'All Templates',
    deleteFolderTitle: 'Delete folder',
    loading: 'Loading...',
    emptyFolder: 'No templates yet in this folder',
    createTemplate: 'Create template',
    table: {
      name: 'Name',
      folder: 'Folder',
      engine: 'Engine',
      recipe: 'Recipe',
      updated: 'Updated',
    },
    modal: {
      folderName: 'Folder name',
      cancel: 'Cancel',
      create: 'Create',
      name: 'Name',
      folder: 'Folder',
      noFolder: 'No folder',
    },
    confirms: {
      deleteTemplate: 'Delete this template?',
      deleteFolder: 'Delete folder "{{name}}"? Templates will be unassigned from this folder.',
    },
    errors: {
      deleteTemplate: 'Failed to delete template',
      createFolder: 'Failed to create folder',
      deleteFolder: 'Failed to delete folder',
    },
    uncategorized: 'No folder',
    folderFallback: 'Folder',
  },
  assets: {
    title: 'Assets',
    upload: 'Upload',
    loading: 'Loading...',
    empty: 'No assets uploaded',
    confirmDelete: 'Delete this asset?',
    table: {
      name: 'Name',
      type: 'Type',
      sharedHelper: 'Shared Helper',
    },
    yes: 'Yes',
    no: 'No',
  },
  scripts: {
    title: 'Scripts',
    save: 'Save',
    new: 'New',
    scriptNamePrompt: 'Script name:',
    newScriptTitle: 'Create New Script',
    scriptNameLabel: 'Script name',
    scriptNamePlaceholder: 'Enter script name',
    scriptNameRequired: 'Script name is required.',
    create: 'Create',
    creating: 'Creating...',
    createFailed: 'Could not create script.',
    saved: 'Saved',
    confirmDelete: 'Delete?',
    template: 'Template',
    trigger: 'Trigger',
    triggerBefore: 'before',
    triggerAfter: 'after',
    globalAllTemplates: 'Global (all templates)',
    empty: 'Select or create a script',
    exampleLabel: 'Example',
    selectExample: 'Select script example',
    insertExample: 'Insert example',
    insertBase: 'Insert base',
    baseInserted: 'Base script inserted.',
    exampleInserted: 'Example inserted in editor.',
    confirmReplaceWithBase: 'This will replace current script code with trigger base. Continue?',
    confirmReplaceWithExample: 'This will replace current script code. Continue?',
    aiGenerate: 'Generate with AI',
    aiPromptTitle: 'Generate Script with AI',
    aiPromptPlaceholder: 'Describe what the script should do...\ne.g. "Add a calculated tax field of 16% to each invoice line item"',
    aiPromptCounter: '{{count}} / {{max}} characters',
    aiGenerating: 'Generating...',
    aiApplied: 'AI-generated script applied.',
    aiFailed: 'AI generation failed.',
  },
  users: {
    title: 'Users',
    newUser: 'New User',
    loading: 'Loading...',
    empty: 'No users yet',
    createFirst: 'Create first user',
    table: {
      email: 'Email',
      role: 'Role',
      activePlan: 'Active plan',
      noPlan: 'No plan',
      created: 'Created',
    },
    tooltips: {
      changePassword: 'Change password',
      deleteUser: 'Delete user',
    },
    modal: {
      cancel: 'Cancel',
      create: 'Create',
      password: 'Password',
      role: 'Role',
      changePassword: 'Change password',
      user: 'User',
      newPassword: 'New password',
      savePassword: 'Save password',
    },
    errors: {
      load: 'Could not load users',
      create: 'Could not create user',
      delete: 'Could not delete user',
      updateRole: 'Could not update role',
      updatePassword: 'Could not update password',
      passwordMin: 'Password must be at least 8 characters',
    },
    messages: {
      passwordUpdated: 'Password updated',
      confirmDelete: 'Delete user {{email}}?',
    },
  },
  jobs: {
    title: 'Jobs',
    refresh: 'Refresh',
    showAll: 'Show all',
    onlyScriptErrors: 'Only script errors',
    viewPayload: 'View payload',
    loading: 'Loading...',
    empty: 'No jobs',
    cancel: 'Cancel',
    scriptSummaryOk: '{{executed}} ok',
    scriptSummaryWithErrors: '{{executed}} ok / {{failed}} errors',
    payload: {
      title: 'Render request payload',
      close: 'Close',
      jobId: 'Job',
      loading: 'Loading payload...',
      loadError: 'Could not load payload data',
    },
    table: {
      id: 'ID',
      type: 'Type',
      status: 'Status',
      scripts: 'Scripts',
      created: 'Created',
      started: 'Started',
      finished: 'Finished',
      actions: 'Actions',
    },
  },
  reports: {
    title: 'Reports',
    loading: 'Loading...',
    empty: 'No reports generated yet',
    download: 'Download',
    table: {
      id: 'ID',
      contentType: 'Content Type',
      created: 'Created',
      expires: 'Expires',
    },
  },
  settings: {
    title: 'Settings',
    importExport: 'Import / Export',
    importExportText: 'Export all templates, assets, scripts, folders, and tags as a ZIP bundle, or import from a previously exported bundle.',
    exportAll: 'Export All',
    importing: 'Importing...',
    importBundle: 'Import Bundle',
    imported: 'Imported: {{templates}} templates, {{assets}} assets, {{scripts}} scripts',
    about: 'About',
    aboutText: 'Report Engine v0.1.0 – Reporting server platform',
  },
  templateEditor: {
    invalidSampleData: 'Sample Data must be valid JSON',
    loadFailed: 'Could not load template',
    openFailed: 'Could not open template',
    backToTemplates: 'Back to Templates',
    noTemplateSelected: 'No template selected',
    preview: 'Preview',
    generatingPdf: 'Generating PDF...',
    renderPdf: 'Render PDF',
    saving: 'Saving...',
    save: 'Save',
    tabs: {
      html: 'Template HTML',
      helpers: 'Helpers JS',
      data: 'Sample Data',
    },
    previewRefresh: 'Refresh',
    previewRefreshing: 'Refreshing...',
    previewHint: 'Click Preview to generate the preview.',
    debugConsole: 'Debug console',
    debugConsoleHint: 'Capture console.log/warn/error from beforeRender scripts and Helpers JS during preview.',
    consoleTitle: 'Console',
    consoleClear: 'Clear',
    consoleCollapse: 'Collapse console',
    consoleExpand: 'Expand console',
    consoleEmpty: 'No console output yet. Run Preview to capture helper/script logs.',
    consoleDisabled: 'Debug console is disabled.',
    autoPreview: 'Auto preview',
    autoPreviewHint: 'When disabled, preview updates only when you click Preview/Refresh.',
    versions: 'Versions',
    publish: 'Publish',
    versionsTitle: 'Template Versions',
    versionsLoadFailed: 'Could not load template versions.',
    versionHistory: 'Version history',
    loadingVersions: 'Loading versions...',
    noVersions: 'No versions yet.',
    versionLabelPlaceholder: 'Version label (optional)',
    versionNotePlaceholder: 'Change note (optional)',
    saveAsVersion: 'Save as version',
    saveAndPublishVersion: 'Save & publish',
    versionCreated: 'Version created.',
    versionCreatedPublished: 'Version created and published.',
    versionCreateFailed: 'Could not create version.',
    versionRestore: 'Restore',
    versionRollback: 'Rollback',
    versionRestoreConfirm: 'Restore this version into the current template? Unsaved changes will be overwritten.',
    versionRestored: 'Rollback completed and selected version is now published.',
    versionRestoreFailed: 'Could not restore this version.',
    versionPublish: 'Publish',
    versionPublished: 'Version published.',
    versionPublishFailed: 'Could not publish this version.',
    published: 'Published',
    statusDraft: 'Draft',
    statusPublished: 'Published',
    statusNoPublished: 'No published version',
    statusDraftHint: 'There are unpublished changes. Render uses the latest published version.',
    statusPublishedHint: 'Current editor content matches the published version.',
    renderFailed: 'Render failed',
    // Dashboard
    'dashboard.welcome': 'Welcome back',
    'dashboard.subtitle': 'Here\'s your report engine overview',
    'dashboard.loading': 'Loading dashboard...',
    'dashboard.loadFailed': 'Could not load dashboard data.',
    'dashboard.templates': 'Templates',
    'dashboard.scripts': 'Scripts',
    'dashboard.assets': 'Assets',
    'dashboard.totalJobs': 'Total Jobs',
    'dashboard.usageTitle': 'Plan Usage This Month',
    'dashboard.renders': 'Renders',
    'dashboard.templatesActive': 'Active Templates',
    'dashboard.aiGenerations': 'AI Generations',
    'dashboard.storage': 'Storage (GB)',
    'dashboard.planDetails': 'Plan Details',
    'dashboard.apiRate': 'API Rate',
    'dashboard.concurrency': 'Concurrency',
    'dashboard.studio': 'Studio',
    'dashboard.apiAccess': 'API Access',
    'dashboard.priorityQueue': 'Priority Queue',
    'dashboard.customBranding': 'Custom Branding',
    'dashboard.enabled': 'Enabled',
    'dashboard.disabled': 'Disabled',
    'dashboard.subscriptionStatus': 'Status',
    'dashboard.jobHealth': 'Job Health',
    'dashboard.successRate': 'Success',
    'dashboard.succeeded': 'succeeded',
    'dashboard.failed': 'failed',
    'dashboard.running': 'running',
    'dashboard.queued': 'queued',
    'dashboard.recentJobs': 'Recent Jobs',
    'dashboard.noJobs': 'No jobs yet. Render a template to see activity here.',
    'dashboard.month': 'mo',
    planLimitReached: 'You reached your current plan limit. Please upgrade to a higher plan to continue.',
    aiGenerate: 'Generate with AI',
    aiPromptTitle: 'Generate Template with AI',
    aiPromptPlaceholder: 'Describe the report template you need...\ne.g. "Professional invoice with company logo, line items table, subtotal, tax, and total. Include customer info and payment terms."',
    aiGenerationModeLabel: 'Generate',
    aiGenerationModeAll: 'HTML + Helpers + Sample Data',
    aiGenerationModeHtml: 'Only HTML',
    aiGenerationModeHelpers: 'Only Helpers JS',
    aiGenerationModeSampleData: 'Only Sample Data',
    aiPromptCounter: '{{count}} / {{max}} characters',
    aiGenerating: 'Generating...',
    aiApplied: 'AI-generated template applied.',
    aiFailed: 'AI generation failed.',
    aiConfirmOverwrite: 'This will replace your current template content. Continue?',
    visualBlock: {
      flexContainer: 'Flex Container',
      heading: 'Heading',
      text: 'Paragraph',
      textSingleLine: 'Text (1 line)',
      conditional: 'Conditional Block',
      button: 'Button',
      image: 'Image',
      columns2: '2 Columns',
      list: 'List',
      table: 'Table',
      divider: 'Divider',
      spacer: 'Spacer',
      raw: 'Raw HTML',
    },
    visualAlignContent: 'Align content',
    visualWidth: 'Width',
    visualHeight: 'Height',
    visualHeightPlaceholder: 'auto / 120px',
    visualMinHeight: 'Min height',
    visualMargin: 'Margin',
    visualText: 'Text',
    visualSectionTitle: 'Section title',
    visualParagraphPlaceholder: 'Write your paragraph here...',
    visualTextBindingPlaceholder: 'Text: {{invoice.number}}',
    visualAlign: 'Align',
    visualCondition: 'Condition',
    visualConditionPlaceholder: 'invoice.number or (eq invoice.status "paid")',
    visualThenText: 'Then text',
    visualElseText: 'Else text',
    visualElseTextPlaceholder: 'No invoice number',
    visualLabel: 'Label',
    visualButtonPlaceholder: 'Call to action',
    visualUrl: 'URL',
    visualAlt: 'Alt',
    visualImageAltPlaceholder: 'Image alt text',
    visualImageHeightPlaceholder: 'auto / 80px',
    visualAlignSelf: 'Align self',
    visualObjectFit: 'Object fit',
    visualObjectPosition: 'Object position',
    visualLeft: 'Left',
    visualLeftPlaceholder: 'Left column content',
    visualRight: 'Right',
    visualRightPlaceholder: 'Right column content',
    visualArraySource: 'Array source',
    visualStyle: 'Style',
    visualBullets: 'Bullets (ul)',
    visualNumbered: 'Numbered (ol)',
    visualItemTemplate: 'Item template',
    visualItemTemplatePlaceholder: 'Date: {{this.date}}',
    visualEmptyText: 'Empty text',
    visualNoItems: 'No items',
    visualNoRows: 'No rows',
    visualColumnN: 'Column {{index}}',
    visualHeader: 'Header',
    visualCellTemplate: 'Cell template',
    visualRemoveColumn: 'Remove column',
    visualAddColumn: 'Add column',
    visualHeightPx: 'Height (px)',
    visualHtml: 'HTML',
    visualCustomCssPlaceholder: 'margin-top:8px;border:1px solid #ddd;',
    visualSource: 'Source',
    visualSourceCustom: 'Custom URL / expression',
    visualSourceData: 'Sample data binding',
    visualSourceAsset: 'Asset',
    visualUrlOrBindingPlaceholder: 'https://... or {{...}}',
    visualDataPath: 'Data path',
    visualCustomPath: 'Custom path',
    visualLogoPathPlaceholder: 'invoice.logoUrl',
    visualAssetImage: 'Asset image',
    visualSelectAsset: 'Select an asset...',
    visualNoAssetsFound: 'No assets found. Upload assets first.',
    visualIf: 'IF',
    visualTableSummary: 'Table · {{count}} cols · {{source}}',
    visualOptionAuto: 'Auto',
    visualOptionContain: 'Contain',
    visualOptionCover: 'Cover',
    visualOptionFill: 'Fill',
    visualOptionNone: 'None',
    visualOptionScaleDown: 'Scale down',
    visualOptionLeft: 'Left',
    visualOptionRight: 'Right',
    visualOptionCenter: 'Center',
    visualOptionStart: 'Start',
    visualOptionEnd: 'End',
    visualOptionStretch: 'Stretch',
    visualOptionSpaceBetween: 'Space between',
    visualOptionSpaceAround: 'Space around',
    visualOptionSpaceEvenly: 'Space evenly',
  },
  landing: {
    nav: {
      home: 'Home',
      features: 'Features',
      how: 'How it works',
      security: 'Security',
      pricing: 'Pricing',
      apiReference: 'API Reference',
      docs: 'Docs',
      primary: 'Primary navigation',
    },
    login: 'Sign In',
    dashboard: 'Dashboard',
    logout: 'Sign Out',
    startFree: 'Start Free',
    seeHow: 'See how it works',
    createFree: 'Create free account',
    skipToContent: 'Skip to content',
    menuOpen: 'Open menu',
    menuClose: 'Close menu',
    hero: {
      titleLine1: 'Generate PDF reports',
      titleLine2: 'professional and automated',
      subtitle: 'Design templates with Handlebars, run custom scripts, and produce production-ready documents through a simple REST API.',
      generate: 'Generate',
      professionalPdfs: 'professional PDFs',
      atAnyScale: 'at any scale',
      subtitleV2: 'Design templates with Handlebars, run custom scripts, and produce production-ready PDF documents through a simple REST API. Powered by AI.',
    },
    nowWithAi: 'Now with AI generation',
    trustedBy: 'Trusted by 2,000+ developers',
    scroll: 'Scroll',
    howBadge: 'Simple workflow',
    pricingBadge: 'Transparent pricing',
    pricingHeadline: 'Plans that grow with you',
    pricingFootnote: 'All plans include SSL, 99.9% uptime SLA, and GDPR compliance',
    stats: {
      title: 'Built for scale',
      subtitle: 'Everything included in the Pro plan',
      renders: 'Renders / month',
      storage: 'Storage',
      templates: 'Active templates',
      apiCalls: 'API calls',
      concurrent: 'Concurrent renders',
      ai: 'AI generations',
      versions: 'Template versions',
      avg: 'Avg render time',
    },
    featuresHeadline: 'All the power, none of the complexity',
    featuresSubHeadline: 'From design to delivery, everything you need to generate reports at scale.',
    sections: {
      featuresTitle: 'Features',
      featuresSubtitle: 'Everything you need to generate reports at scale.',
      howTitle: 'How it works',
      howSubtitle: 'Three steps to your first reports.',
      securityTitle: 'Security',
      securitySubtitle: 'Your information is always protected.',
      pricingTitle: 'Pricing',
      pricingSubtitle: 'Choose the plan that best fits your needs.',
      ctaTitle: 'Ready to automate your reports?',
      ctaSubtitle: 'Create your free account and generate your first PDF in less than 5 minutes.',
    },
    features: {
      handlebarsTitle: 'Handlebars templates',
      handlebarsDesc: 'Design your documents with HTML + Handlebars. Built-in helpers, partials, and dynamic data.',
      scriptsTitle: 'Custom scripts',
      scriptsDesc: 'Run JavaScript logic before or after render. Transform data, add watermarks, or validate content.',
      previewTitle: 'Real-time preview',
      previewDesc: 'See your reports instantly in Studio. Edit HTML, CSS and JSON data and watch live changes.',
      apiTitle: 'Full REST API',
      apiDesc: 'Render documents from any language. Endpoints for templates, assets, scripts and async jobs.',
      jobsTitle: 'Template versioning & publishing',
      jobsDesc: 'Track every change, compare versions, and publish stable templates with one click.',
      versioningTitle: 'Template versioning & publishing',
      versioningDesc: 'Track every change, compare versions, and publish stable templates with one click.',
      aiTitle: 'AI generation',
      aiDesc: 'AI-powered document generations with intelligent content and layout suggestions.',
      visualTitle: 'Visual builder',
      visualDesc: 'Drag-and-drop interface to build templates visually. No code required to get started.',
      brandingTitle: 'Priority queue',
      brandingDesc: 'Render critical documents first with configurable priority levels and queue control.',
      priorityQueueTitle: 'Priority queue',
      priorityQueueDesc: 'Render critical documents first with configurable priority levels and queue control.',
      tenantTitle: 'Team collaboration',
      tenantDesc: 'Invite teammates, share templates, and review changes together before publishing.',
      collaborationTitle: 'Team collaboration',
      collaborationDesc: 'Invite teammates, share templates, and review changes together before publishing.',
    },
    steps: {
      oneTitle: 'Design your template',
      oneDesc: 'Open Studio, create a template with HTML + Handlebars, and add CSS styles. Upload logos and images as assets.',
      twoTitle: 'Connect your data',
      twoDesc: 'Send the JSON you need: invoices, financial reports, inventory. Helpers and scripts do the rest.',
      threeTitle: 'Generate and download',
      threePrefix: 'Call endpoint',
      threeSuffix: 'and receive your PDF instantly. Or schedule automatic generation with jobs.',
    },
    securityItems: {
      jwt: 'JWT authentication with short-lived tokens',
      roles: 'Roles and permissions: admin, editor, viewer',
      isolation: 'Data isolation by tenant and user',
      sandbox: 'Script execution in controlled sandbox',
      tls: 'HTTPS/TLS in all communications',
      audit: 'Real-time monitoring and audit logs',
    },
    plans: {
      starter: 'Starter',
      pro: 'Pro',
      enterprise: 'Enterprise',
      month: '/month',
      contact: 'Contact',
      starterCta: 'Start free',
      proCta: 'Choose Pro',
      enterpriseCta: 'Contact sales',
      popular: 'Popular',
      starterF1: '100 renders/month',
      starterF2: '5 templates',
      starterF3: '1 user',
      starterF4: 'Community support',
      proF1: '5,000 renders/month',
      proF2: 'Unlimited templates',
      proF3: '5 users',
      proF4: 'Scheduled jobs',
      proF5: 'Priority support',
      entF1: 'Unlimited renders',
      entF2: 'Unlimited templates',
      entF3: 'Unlimited users',
      entF4: 'Dedicated SLA',
      entF5: '24/7 support',
    },
    footer: {
      tagline: 'Professional PDF report generation.',
      product: 'Product',
      legal: 'Legal',
      support: 'Support',
      terms: 'Terms of service',
      privacy: 'Privacy policy',
      notice: 'Legal notice',
      docs: 'Documentation',
      api: 'API Reference',
      contact: 'Contact',
      copyright: '© {{year}} Company name. All rights reserved.',
    },
  },
  dashboard: {
    welcome: 'Welcome back',
    subtitle: 'Here\'s your report engine overview',
    loading: 'Loading dashboard...',
    loadFailed: 'Could not load dashboard data.',
    templates: 'Templates',
    scripts: 'Scripts',
    assets: 'Assets',
    totalJobs: 'Total Jobs',
    usageTitle: 'Plan Usage This Month',
    renders: 'Renders',
    templatesActive: 'Active Templates',
    aiGenerations: 'AI Generations',
    storage: 'Storage (GB)',
    planDetails: 'Plan Details',
    enabled: 'Enabled',
    disabled: 'Disabled',
    subscriptionStatus: 'Status',
    jobHealth: 'Job Health',
    successRate: 'Success',
    succeeded: 'succeeded',
    failed: 'failed',
    running: 'running',
    queued: 'queued',
    recentJobs: 'Recent Jobs',
    noJobs: 'No jobs yet. Render a template to see activity here.',
    month: 'mo',
    apiRate: 'API Rate',
    concurrency: 'Concurrency',
    active: 'active',
    inactive: 'inactive',
    job: 'job',
    feature: {
      studio: 'Studio',
      apiAccess: 'API Access',
      priorityQueue: 'Priority Queue',
      customBranding: 'Custom Branding',
      aiGeneration: 'AI Generation',
      visualBuilder: 'Visual Builder',
      scheduledJobs: 'Scheduled Jobs',
      templateVersioning: 'Template Versioning',
    },
    timeJustNow: 'just now',
    timeMinutesAgo: '{{count}}m ago',
    timeHoursAgo: '{{count}}h ago',
    timeDaysAgo: '{{count}}d ago',
    userFallback: 'User',
  },
};
